export default function ArchiveIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.19998 12.7999H12.8C13.6825 12.7999 14.4 12.0824 14.4 11.1999V5.1999C14.4 4.3174 13.6825 3.5999 12.8 3.5999H9.06748C8.89498 3.5999 8.72498 3.5449 8.58748 3.4399L7.62748 2.7199C7.34998 2.5124 7.01248 2.3999 6.66748 2.3999H3.19998C2.31748 2.3999 1.59998 3.1174 1.59998 3.9999V11.1999C1.59998 12.0824 2.31748 12.7999 3.19998 12.7999Z" fill="#006DA3"/>
        </svg>
    );
}